import { useEffect, useState } from 'react'

export interface MinecraftLiveStatus {
  online: boolean
  version?: string | null
  protocol?: number | null
  players?: {
    online: number
    max: number
  }
  motd?: string
}

export default function useMinecraftStatus(enabled: boolean) {
  const [status, setStatus] = useState<MinecraftLiveStatus | null>(null)

  useEffect(() => {
    if (!enabled) {
      setStatus(null)
      return undefined
    }

    let active = true
    const controller = new AbortController()

    const load = async () => {
      try {
        const response = await fetch('/api/minecraft/status', {
          signal: controller.signal,
        })
        if (!response.ok) throw new Error(`Status request failed: ${response.status}`)
        const next = (await response.json()) as MinecraftLiveStatus
        if (active) setStatus(next)
      } catch {
        if (active && !controller.signal.aborted) setStatus({ online: false })
      }
    }

    void load()
    const interval = window.setInterval(load, 30_000)
    return () => {
      active = false
      controller.abort()
      window.clearInterval(interval)
    }
  }, [enabled])

  return status
}
